import React from 'react';
import { useSelector } from 'react-redux';
import { MarketingSurveyAsync } from 'site-modules/shared/components/marketing-survey/marketing-survey-async';
import { MinHeightWrapper } from 'site-modules/shared/components/min-height-wrapper/min-height-wrapper';

import './appraisal-marketing-survey.scss';

export const AppraisalMarketingSurvey = () => {
  const isAppraiseFinished = useSelector(state => Boolean(state.appraisal?.isAppraiseFinished));

  return (
    isAppraiseFinished && (
      <MinHeightWrapper componentType="MARKETING_SURVEY_2ROW" className="appraisal-marketing-survey my-1_5">
        <MarketingSurveyAsync
          className="card d-block px-1 px-md-2 py-1_5"
          labelClassName="text-gray-dark"
          questionClassName="heading-3 text-md-start mb-1 mb-md-1_5"
          answerClassName="answer flex-column flex-sm-row no-width"
          buttonClassName="submit-btn d-block d-sm-inline-block px-md-3_5 py-0_5 ms-0 mt-0_5 mt-sm-0 ms-sm-1"
          thankYouClassName="heading-3"
          colSize={{ question: 12, answer: 12 }}
          alwaysShow
          isEmbedded
        />
      </MinHeightWrapper>
    )
  );
};
